const SegnalazioneFlowState = {
    IN_COMPILAZIONE: "In compilazione",
    PROTOCOLLATA: "Inviata",
    RETTIFICATA: "Integrata",
    CANCELLATA : "Cancellata",
    FASE_DI_CREAZIONE : "In compilazione",
    FASE_DI_RETTIFICA : "Integrazione",
    DA_COMPLETARE : "Da completare",
    CHIUSURA_LO : "Chiusura-L0",
    CHIUSURA_L1 : "Chiusura-L1",
    ASSEGNATAFUNZ : "Assegnata",
    PRESAINCARICO : "Presa in Carico",
    INLAVORAZIONECONCLUSAFASEUNO : "In lavorazione / Conclusa prima fase",
    INLAVORAZIONE : "In lavorazione ",
    TEMPSOSPESA : "Temporaneamente sospesa ",
    ANALISICONCLUSE :"Analisi Concluse ",
    NONPORTAREINCOMITATO :"Caso da non portare in comitato",
    CASODISCUSSO :"Caso già discusso in comitato ( non avvio )",
    CASOABM :"Caso da trasmettere ad ABM",
    INVIOURI :"Inviata nota a URI",
    CONSEGNATABOZZANOTE: "Consegnata bozza nota ai Revisori ",
    BOZZAREVISIONATA: "Bozza Revisionata",
    ALTROESITO: "Altro esito (specificare in note)",
    DISCUSSACOMITATOAVVIO: "Discussa in Comitato MAB - Avvio",
    DISCUSSACOMITATONOAVVIO: "Discussa in Comitato MAB - Non avvio",
    NOTARITIRATA: "Nota Ritirata ",
    DISCUSSACOMITATOSOSPESA: "Discussa in Comitato MAB - Sospesa",
}

export default SegnalazioneFlowState;